const elog = require('@reverbdotcom/elog').default;
const events = require('@reverbdotcom/reverb-event').reverb.event;

function trackArticleView(articleId, aid, utmCampaign) {
  const event = new events.ArticleView({
    url: window.location.href,
    aid: aid || '',
    referer: document.referrer,
    utm_campaign: utmCampaign || '',
    article_id: articleId.toString(),
  });

  elog.track(event);
}

module.exports = {
  trackArticleView,
};



// WEBPACK FOOTER //
// ./javascripts/components/event_tracking.js